<a
    [href]="loginUrl"
    class="message--module-inactive message--module-inactive--gmail"
    (click)="activeModal.dismiss()">
    <strong>You are not logged in with Google.</strong>
    <small>Click to connect your account.</small>
</a>
